export default __webpack_public_path__ + "static/media/sucursal1.911db739.png";